<div class="modal-header">
    <h5 class="modal-title">Hiển thị QR</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.dismiss()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  
  <div class="modal-body p-3">
    <div class="text-left">
      <form [formGroup]="formData">
        <div class="row">
          <!-- SELECT DEVICE -->
          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">
              {{ "Serial" | translate }}
            </label>
  
            <div class="col-md-10">
              <ng-select
                [items]="listDevicesQr"
                bindLabel="serial_number"
                bindValue="serial_number"
                formControlName="serial_number"
                (change)="onDeviceChange($event)"
                placeholder="{{ 'Chọn thiết bị' | translate }}"
                [compareWith]="compareFn"
              >
              </ng-select>
            </div>
          </div>
  
          <!-- QR -->
          <div class="form-group row col-md-12">
            <div class="col-md-12 d-block justify-content-center">
              <div class="d-flex justify-content-center">
                <div
                  class="borderQR d-flex flex-column align-items-center"
                  *ngIf="flagDownQr"
                  #qrContainer
                >
                  <div class="qr-with-text canvas-container">
                    <qr-code
                      class="custom-qr-code"
                      [value]="qrCodeValue"
                      [size]="400"
                      [errorCorrectionLevel]="'M'"
                    >
                    </qr-code>
  
                    <!-- TEXT -->
                    <div class="text-center user-info">
                      <h3
                        class="account-name"
                        [ngClass]="{
                          'long-name':
                            dataUser?.terminal_bank_acc_name?.length > 25,
                          'very-long-name':
                            dataUser?.terminal_bank_acc_name?.length > 35
                        }"
                      >
                        {{ dataUser?.terminal_bank_acc_name }}
                      </h3>
  
                      <h3
                        class="account-number"
                        [ngClass]="{
                          'long-name':
                            dataUser?.terminal_bank_acc_name?.length > 25,
                          'very-long-name':
                            dataUser?.terminal_bank_acc_name?.length > 35
                        }"
                      >
                        {{ dataUser?.terminal_bank_acc }}
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
  
              <!-- BUTTON -->
              <div class="d-flex justify-content-center mt-3">
                <div class="col-12 col-md-3 p-0">
                  <button class="btn-viettel col" (click)="downloadQRCode()">
                    <span class="m-auto">Tải xuống mã QR</span>
                  </button>
  
                  <button class="btn-viettel col mt-2" (click)="printQRCode()">
                    In QR Code
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
  
        <!-- FOOTER -->
        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="activeModal.close()"
          >
            {{ "Đóng" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>